exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navbar {\n  border-bottom: 1px solid #cdd3d8;\n  background-color: rgba(0,0,0,0.05);\n  font-weight: 400;\n  font-size: 80%;\n  font-family: 'Lato', Arial, Helvetica, Sans-serif;\n}\n.nabbar-list {\n  min-width: 300px;\n  width: 50%;\n  width: calc(40vw + 180px);\n  margin-right: auto;\n  margin-left: auto;\n}\n.nabbar-list li {\n  display: inline;\n  line-height: 300%;\n  margin-right: 15px;\n}\n.nabbar-list li a {\n  cursor: pointer;\n  text-decoration: none;\n}\n.nabbar-list li a:hover {\n  text-decoration: none;\n}\n", ""]);

// exports
